import Vue from 'vue'
import Vuex from 'vuex';
import apiClient from "./apiClient";
import { i18n } from "../shared/i18n"

Vue.use(Vuex)


export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    // Fixed for election
    electionUrl: null,

    partnerBranding: {
      logo: null,
      link: null
    },

    organisationBranding: {
      name: null,
      logo: null
    },

    // This value will get updated when a
    // new election json is fetched from server
    election: null,
    locales: [],
    currentLocale: i18n.locale,

    // Used to determine if the server is available
    lostConnectionToServer: false,

    // Overall theme color
    theme: 'light'
  },
  getters:{
    firstAvailableLocale(state){
      return state.locales.includes(i18n.locale) ? i18n.locale : state.locales[0]
    }
  },
  mutations: {
    setPartnerBranding(state, partnerBranding){
      state.partnerBranding = partnerBranding
    },
    setOrganisationBranding(state, organisationBranding){
      state.organisationBranding = organisationBranding
    },
    setElectionUrl(state, { electionUrl }){
      state.electionUrl = electionUrl
    },
    setElection(state, election){
      state.election = election
    },
    setLocales(state, locales){
      state.locales = locales
    },
    setLocale(state, locale){
      if(i18n.availableLocales.includes(locale)){
        state.currentLocale = locale
        i18n.locale = locale
      }
    },
  }
})
